import { render, staticRenderFns } from "./VendorLogo.vue?vue&type=template&id=231108f6&scoped=true&"
import script from "./VendorLogo.vue?vue&type=script&setup=true&lang=js&"
export * from "./VendorLogo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./VendorLogo.vue?vue&type=style&index=0&id=231108f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231108f6",
  null
  
)

export default component.exports